import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-6">
      <h1 className="font-serif-display text-[8rem] md:text-[12rem] font-black text-background-200 select-none leading-none">
        404
      </h1>
      <div className="relative z-10 -mt-8 md:-mt-12">
        <h2 className="font-serif-display text-foreground-50 text-2xl md:text-3xl">
          Page Not Found
        </h2>
        <p className="mt-4 text-foreground-500 text-base max-w-md mx-auto">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block mt-8 bg-primary-500 text-background-50 font-label uppercase text-xs tracking-widest px-8 py-4 rounded-md hover:bg-primary-400 transition-all duration-300 cursor-pointer whitespace-nowrap hover-lift"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}